import { comments } from '@/mocks/home';

const avatarTone = ['bg-primary-200 text-primary-900', 'bg-accent-200 text-accent-900', 'bg-secondary-300 text-secondary-900'];

export default function BuzzWall() {
  return (
    <section id="buzz" className="relative w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-chat-3-line" /> COMMUNITY
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              圈内热评 · 围观现场
            </h2>
          </div>
          <button
            type="button"
            className="inline-flex w-fit cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-background-50 px-4 py-2 text-sm font-semibold text-foreground-800 ring-1 ring-background-300 transition-colors hover:ring-secondary-400"
          >
            <i className="ri-edit-2-line" /> 我也要说两句
          </button>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4">
          {comments.map((c, idx) => (
            <figure
              key={c.user}
              className="flex flex-col justify-between rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <blockquote className="text-sm leading-relaxed text-foreground-800">
                “{c.text}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-background-100 pt-4">
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-sm font-bold ${avatarTone[idx % avatarTone.length]}`}
                >
                  {c.user.replace(/[@（]/g, '').slice(0, 1).toUpperCase()}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-sm font-semibold text-foreground-950">{c.user}</p>
                  <p className="text-xs text-secondary-500">{c.role}</p>
                </div>
                <button
                  type="button"
                  className="flex cursor-pointer items-center gap-1 text-xs text-foreground-500 transition-colors hover:text-primary-600"
                >
                  <i className="ri-heart-3-line" />
                  <span>{c.likes}</span>
                </button>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}